export const OUTREACH_AGGREGATE = 'report:outreach-aggreage';
export const GUEST_SUMMARY = 'report:guest-summary';
export const DONOR_SUMMARY = 'report:donor-summary';
export const LOW_STOCK_ITEMS = 'report:low-stock-items';
export const ITEMS_AND_PACKAGES_SKUS = 'report:items-skus';
export const VISIT_HISTORY = 'report:visit-history';
